/**
 * The door rule, pure: what interact does to a door, given whether the doorway is
 * obstructed. The obstruction itself is detected by a physics sensor in the engine;
 * this module only ever sees the boolean.
 */

import type { DoorState } from './interaction';

/**
 * A closed door always opens. An open door closes only onto an empty doorway — a
 * blocked close is refused outright rather than swinging into the obstruction, which
 * is the "never traps or crushes" requirement in its simplest form.
 */
export function toggleDoor(state: DoorState, isDoorwayBlocked: boolean): DoorState {
  if (state === 'closed') return 'open';
  return isDoorwayBlocked ? 'open' : 'closed';
}
